<template>
  <div class="myPlaylist">
    <!-- <header-area></header-area> -->
    <banner-search></banner-search>
    <playlist-cards v-if="showPlayListCards"></playlist-cards> 
    <libraryCards v-if ="showLibraryCard && $store.getters.getUserSingleConceptsCollection!=undefined && $store.getters.getUserSingleConceptsCollection!=null && $store.getters.getUserSingleConceptsCollection.length ==0"></libraryCards>
    <newVideoCards v-if ="showLibraryCard && showNewVideoCard && $store.getters.getUserSingleConceptsCollection!=undefined && $store.getters.getUserSingleConceptsCollection!=null && $store.getters.getUserSingleConceptsCollection.length ==0"></newVideoCards> 
     <infinite-loading v-if="$store.getters.getUserSingleConceptsCollection!=undefined && $store.getters.getUserSingleConceptsCollection!=null && $store.getters.getUserSingleConceptsCollection.length ==0" @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
    </infinite-loading>
    <!-- <footerArea></footerArea> -->
 </div>
</template>

<script>
import {INSTANCE_NAME} from '@/components/common/constants.js'
import { EventBus } from '@/main.js'
import InfiniteLoading from 'vue-infinite-loading'
import headerArea from '@/components/common/headerLogin.vue'
import bannerSearch from '@/components/home/bannerSearch.vue'
import playlistCards from './playlistCards'
import footerArea from '@/components/common/footerArea'
import libraryCards from '@/components/home/libraryCards'
import newVideoCards from '@/components/home/newVideoCards'
export default {
  name: 'playlist',
  components: {
    headerArea,
    bannerSearch,
    playlistCards,
    libraryCards,
    newVideoCards,
    footerArea,
    InfiniteLoading
  },
  data () {
    return {
      showPlayListCards: false,
      profileId: this.$store.getters.getProfileDetails.profileId,
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    this.$store.dispatch('resetPlayListDetailsPaginationDetails')
  },
  mounted () {
    if (INSTANCE_NAME === 'MAHADEMY') {
      this.$router.push('/home')
    } else {
      this.fetchPlayList()
      this.GetAllocatedVideosDetails()
      this.$store.dispatch('resetPlayListDetailsPaginationDetails')
      EventBus.$emit('showNav', true)
    }
  },
  methods: {
    GetAllocatedVideosDetails () {
      this.$store.dispatch('fetchUserSingleConceptCollection', {'profileId': this.$store.getters.getProfileDetails.profileId, 'pageNo': 1}).then(res => {
        if (res) {
          this.showPlayListCards = true
        }
      })
    },
    fetchPlayList: function () {
      // var playlistView = this
      this.$store.dispatch('getUserPlayList', {profileId: this.profileId}).then(res => {},
      err => {
        console.log('ERROR_IN_GETTING_PLAYLIST : ', err)
      })
    },
    // infiniteHandler - starts lazy loading
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showLibraryCard = true
        $state.loaded()
      }, 2000)
    },
    // handleScroll - handles scrolling
    handleScroll () {
      if (this.showLibraryCard && !this.showNewVideoCard) {
        setTimeout(() => {
          this.showNewVideoCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            this.globalState.complete()
          }
        }, 2000)
      }
    }
  }
}
</script>
<style lang="scss">
.myPlaylist {
  .bg-gradient-gray {
    background: linear-gradient(to bottom, #fafafa 0%,#ffffff 100%); 
  }
}
</style>




// WEBPACK FOOTER //
// src/components/playList/playlist.vue?6af4d325